export default function PageHeader({ eyebrow, title, accent, description, actions, testId }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 ifl-fade-up" data-testid={testId}>
      <div>
        {eyebrow ? <div className="label-caps mb-3">{eyebrow}</div> : null}
        <h1 className="heading-caps text-3xl md:text-4xl leading-tight">
          {title}
          {accent ? (
            <>
              <br />
              <span className="font-italic-serif normal-case tracking-normal text-3xl md:text-4xl" style={{ color: "var(--ifl-text)" }}>
                {accent}
              </span>
            </>
          ) : null}
        </h1>
        {description ? (
          <p className="font-body text-sm mt-3 max-w-xl" style={{ color: "var(--ifl-muted)" }}>
            {description}
          </p>
        ) : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
